import { MedienGalerie } from '@pilot-hub/ui/components/medien/index'

/** Seite „Medien“: Fotogalerie je Einsatz (auch abgeschlossene), Karte, Download und ZIP – Komponente liegt in packages/ui. */
export function MedienPage() {
  // Der Seitentitel steht schon in der Kopfzeile der AppShell: doppelte Überschrift der Galerie ausblenden
  return <div className="[&_h1]:hidden"><MedienGalerie /></div>
}
